import React, { FunctionComponent, useContext } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { FullScreenWrapper } from 'components/Layouts/FullScreenView/FullScreenWrapper';
import { useAppSelector } from 'hooks/redux';
import { Loader } from 'components/Loader';

interface ErrorWrapperProps {
  children?: React.ReactNode;
  type: 'event' | 'recording' | 'private';
}

export const ErrorWrapper: FunctionComponent<ErrorWrapperProps> = ({
  children,
  type
}) => {
  const channelisLoaded = useAppSelector((state) => state.channel.isLoaded);

  const { isNativeAppWebview } = useContext(UserAgentContext);

  if (!channelisLoaded) {
    return <Loader fillComponent={true} />;
  }

  return (
    <div
      className={classNames(styles['error-page'], {
        [styles['error-page__dark']]: isNativeAppWebview
      })}
    >
      <FullScreenWrapper artworkMode={'theme'} type={type}>
        <div className={classNames(styles['error-page__content'])}>
          {children}
        </div>
      </FullScreenWrapper>
    </div>
  );
};
